class TabsComponent extends HTMLElement {
  constructor() {
    super()
    this.tabList = this.querySelector('[role="tablist"]')
    this.tabs = this.querySelectorAll('[role="tab"]')
    this.panels = this.querySelectorAll('[role="tabpanel"]')

    this.prevBtn = this.querySelector("[data-arrow-prev]")
    this.nextBtn = this.querySelector("[data-arrow-next]")

    // Bind click events
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", this.onTabClick.bind(this))
      tab.addEventListener("keydown", this.onKeyDown.bind(this))
    })

    // 2. Bind click events for Arrows
    if (this.prevBtn)
      this.prevBtn.addEventListener("click", () => this.moveTab(-1))
    if (this.nextBtn)
      this.nextBtn.addEventListener("click", () => this.moveTab(1))
  }

  onTabClick(e) {
    const targetTab = e.currentTarget
    this.switchTab(targetTab)
  }

  // Support Arrow Key Navigation (A11y Requirement)
  onKeyDown(e) {
    const index = Array.from(this.tabs).indexOf(e.currentTarget)
    let nextIndex = null

    if (e.key === "ArrowRight") nextIndex = (index + 1) % this.tabs.length
    if (e.key === "ArrowLeft")
      nextIndex = (index - 1 + this.tabs.length) % this.tabs.length

    if (nextIndex !== null) {
      e.preventDefault()
      this.tabs[nextIndex].focus()
      this.tabs[nextIndex].click() // Optional: Automatic activation on arrow key
    }
  }

  moveTab(direction, setFocus = false) {
    // Find currently active tab index
    const currentIndex = Array.from(this.tabs).findIndex(
      (t) => t.getAttribute("aria-selected") === "true"
    )

    // Safety check: if no tab is selected, start at 0
    const start = currentIndex === -1 ? 0 : currentIndex

    // Calculate new index (Cyclic: loops around start/end)
    const nextIndex = (start + direction + this.tabs.length) % this.tabs.length

    const targetTab = this.tabs[nextIndex]

    // Perform the switch
    this.switchTab(targetTab)

    // Should we move focus?
    // Yes for keyboard users, usually No for mouse users clicking a "Next" button
    if (setFocus) {
      targetTab.focus()
    }
  }

  switchTab(newTab) {
    // 1. Deactivate all tabs
    this.tabs.forEach((tab) => {
      tab.setAttribute("aria-selected", "false")
      tab.setAttribute("tabindex", "-1")
    })

    // 2. Hide all panels
    this.panels.forEach((panel) => {
      panel.classList.remove("is-active")
      panel.setAttribute("aria-hidden", "true")
    })

    // 3. Activate new tab
    newTab.setAttribute("aria-selected", "true")
    newTab.setAttribute("tabindex", "0")

    // 4. Scroll new tab into view (if needed)

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches

    newTab.scrollIntoView({
      behavior: prefersReducedMotion ? "auto" : "smooth",
      block: "nearest", // Vertical alignment (keep it nearest to avoid jumping)
      inline: "center", // Horizontal alignment (puts the tab in the middle)
    })

    // 5. Show target panel
    const panelId = newTab.getAttribute("aria-controls")
    const targetPanel = this.querySelector(`#${panelId}`)
    if (targetPanel) {
      targetPanel.classList.add("is-active")
      targetPanel.setAttribute("aria-hidden", "false")
    }
  }
}

customElements.define("tabs-component", TabsComponent)
